import React from "react";
import { Link } from "react-router-dom";
import { useNavContext } from "../../context-api/nav-context";

const BoilerCover = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="boiler-extras section-wrapper boiler-cover-margin"
      onMouseOver={closeNavbarMenu}
    >
      <div className="boilers-extras-img">
        <div className="img-container">
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643243455/AquaHeat/new%20images/boiler-types-header1_rcoisp.webp"
            alt="boiler extras"
          />
        </div>
      </div>
      <div className="boiler-extras-text">
        <h1 className="title">Boiler Finance</h1>
        <p className="subtitle boiler-margin">
          Finance is available on all boilers. We have a great range of boilers
          from Vaillant, Worcester Bosch and Ideal. With this great range, we
          will always have a boiler to suit any budget.
        </p>
        <Link to="/quotes" className="btn-hero btn-quote">
          Find A Boiler
        </Link>
      </div>
    </section>
  );
};

export default BoilerCover;
